export enum AliasType {
  GeneralAlias = 'General name',
  SpecificAlias = 'Specific unit',
}

export interface ListingMultiUnit {
  id?: number;
  alias?: string;
  newAlias?: string;
  toDelete?: boolean;
  toUpdate?: boolean;
  unitId?: number;
  aliasType?: AliasType; // used for analytic purposes
  tempId?: string;
}

export interface UnitsFormValues {
  add?: string[];
  rename?: { alias: string; id: number }[];
  delete?: number[];
}
